import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap-5';

import ManagedInput from './index';
import classNames from 'classnames';
import { startCase } from 'lodash';

export default class ManagedFormGroup extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    feedback: PropTypes.node,
    feedbackType: PropTypes.string,
    hasError: PropTypes.bool,
    inputClassName: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    showFullLabelBorder: PropTypes.bool,
    type: PropTypes.string
  }

  render() {
    const className = classNames('form-group', this.props.className, {
      boolean: this.props.type === 'checkbox',
      'has-error': this.props.hasError,
      required: this.props.required,
      text: this.props.type === 'textarea'
    });

    return (
      <div className={className}>
        {['autocomplete', 'reactSelect', 'textarea'].includes(this.props.type)
          ? this.renderInputNoContainer()
          : this.renderInputContainer()
        }
      </div>
    );
  }

  renderLabel() {
    let label;
    if (this.props.label) {
      label = this.props.label;
    } else if (this.props.name) {
      label = startCase(this.props.name);
    } else {
      label = '';
      /* eslint-disable no-console */
      console.warn('ManagedFormGroup requires label or name');
      /* eslint-enable no-console */
    }

    const labelClassNameObject = {
      text: this.props.type === 'textarea',
      'full-border': this.props.showFullLabelBorder
    };

    return (
      <label className={classNames('control-label', labelClassNameObject)}>
        {label}
        {this.props.required ? <abbr title="required">*</abbr> : null}
      </label>
    );
  }

  renderInputContainer() {
    return <React.Fragment>
      {this.renderLabel()}
      <div className="form-input-container">
        {this.renderInput()}
      </div>
      {this.renderFeedback()}
    </React.Fragment>;
  }

  renderInputNoContainer() {
    return (
      <div className="form-group-stretch">
        {this.renderLabel()}
        {this.renderInput()}
      </div>
    );
  }

  renderInput() {
    const { children, className, hasError, inputClassName, label, required, ...inputProps } = this.props;
    const noFormControl = ['autocomplete', 'checkboxGroup', 'reactSelect'];
    const props = {
      'aria-label': label,
      ...inputProps,
      className: classNames(inputClassName, { 'form-control': !noFormControl.includes(inputProps.type) }),
    };

    return (
      <ManagedInput {...props}>
        {children}
      </ManagedInput>
    );
  }

  renderFeedback() {
    if (this.props.feedback && this.props.feedback !== false) {
      return (
        <Form.Control.Feedback type={this.props.feedbackType}>
          {this.props.feedback}
        </Form.Control.Feedback>
      );
    }
  }
}
